export default __webpack_public_path__ + "static/media/photo_left_1.3f28f3f9.png";